'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../../external/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var classCallCheck = require('../../../external/@babel/runtime/helpers/esm/classCallCheck.js');

var createClass = require('../../../external/@babel/runtime/helpers/esm/createClass.js');

var assertThisInitialized = require('../../../external/@babel/runtime/helpers/esm/assertThisInitialized.js');

var inherits = require('../../../external/@babel/runtime/helpers/esm/inherits.js');

var createSuper = require('../../../external/@babel/runtime/helpers/esm/createSuper.js');

var defineProperty = require('../../../external/@babel/runtime/helpers/esm/defineProperty.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../../external/classnames/index.js');

var CarouselContext = require('../CarouselContext.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["active", "card", "cardSize", "children", "className", "itemId", "tag"];

var CarouselItem = /*#__PURE__*/function (_Component) {
  inherits['default'](CarouselItem, _Component);

  var _super = createSuper['default'](CarouselItem);

  function CarouselItem() {
    var _this;

    classCallCheck['default'](this, CarouselItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    defineProperty['default'](assertThisInitialized['default'](_this), "moveForward", function () {
      _this.style = {
        position: 'absolute',
        left: '100%',
        display: 'inline-block'
      };
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "moveBackwards", function () {
      _this.style = {
        position: 'absolute',
        left: '-100%',
        display: 'inline-block'
      };
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "makeVisible", function () {
      _this.style = {
        left: 0,
        display: 'inline-block'
      };
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "makeList", function (card, slideIndex) {
      _this.style = {
        left: -slideIndex * card,
        position: 'absolute'
      };
    });
    return _this;
  }

  createClass['default'](CarouselItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
      _this$props.active;
      var card = _this$props.card;
      _this$props.cardSize;
      var children = _this$props.children,
          className = _this$props.className,
          itemId = _this$props.itemId,
          Tag = _this$props.tag,
          attributes = objectWithoutProperties['default'](_this$props, _excluded);
      itemId = parseInt(itemId, 10);
      return /*#__PURE__*/React__default['default'].createElement(CarouselContext['default'].Consumer, null, function (_ref) {
        var activeItem = _ref.activeItem,
            cardSize = _ref.cardSize,
            slide = _ref.slide;
        var slideIndex = activeItem - itemId;
        var classes = index['default'](!card ? 'carousel-item' : 'carousel-item-card-deck', {
          active: itemId === activeItem
        }, className);

        if (slide && !card) {
          if (slideIndex < 0) {
            _this2.moveForward();
          } else if (slideIndex > 0) {
            _this2.moveBackwards();
          } else {
            _this2.makeVisible();
          }
        } else if (card) {
          _this2.makeList(cardSize, slideIndex);
        } else {
          _this2.makeVisible();
        }

        return /*#__PURE__*/React__default['default'].createElement(Tag, _extends['default']({
          "data-testid": "lanl-carousel-item"
        }, attributes, {
          className: classes,
          style: _this2.style,
          "aria-label": "".concat(itemId)
        }), children);
      });
    }
  }]);
  return CarouselItem;
}(React.Component);

CarouselItem.propTypes = {
  active: PropTypes__default['default'].bool,
  card: PropTypes__default['default'].bool,
  cardSize: PropTypes__default['default'].number,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  itemId: PropTypes__default['default'].any,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string])
};
CarouselItem.defaultProps = {
  card: false,
  tag: 'div'
};
exports.CarouselItem = CarouselItem;
exports['default'] = CarouselItem;